const Badge = ({ children }) => {
  return (
    <div className="bg-[#8897F1] w-fit mb-4 shadow-[0px_4px_20px_0px_#8897F1] text-[#F5F6FF] text-base h-[30px] px-3 flex items-center justify-center rounded-[90px]">
      <span className="block -mb-1 sm:mb-0">{children}</span>
    </div>
  );
};

export default Badge;
